const TooltipTheme = {
  tooltip:
    "z-[1080] block p-1 not-italic font-normal no-underline underline-offset-auto normal-case leading-6 tracking-normal break-normal whitespace-normal",
  tooltipInner:
    "max-w-[200px] text-sm py-1.5 px-4 text-white text-center bg-[#6d6d6d] rounded-[0.25rem]",
  fade: "transition-opacity ease-linear motion-reduce:transition-none",
};

export default TooltipTheme;
